export const cardExpiry = [/\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];
